{
	"keys": {
		"preview_select": {"key": 1},
		"preview_rotate": {"key": 2},
		"preview_drag": {"key": 2, "shift": true},
		"preview_zoom": {"key": 2, "ctrl": true},
		"preview_area_select": {"key": 1},
		"confirm": {"key": 13},
		"cancel": {"key": 27},
		"move_tool": {"key": 71},
		"resize_tool": {"key": 83},
		"rotate_tool": {"key": 82},
		"pivot_tool": {"key": 80},
		"vertex_snap_tool": {"key": 88},
		"stretch_tool": null,
		"vertex_snap_mode": null,
		"swap_tools": {"key": 32},
		"open_model_folder": null,
		"open_backup_folder": null,
		"reload": {"key": 116},
		"rename": {"key": 113},
		"delete": {"key": 46},
		"duplicate": {"key": 68, "shift": true},
		"find_replace": null,
		"open_dev_tools": {"key": 73, "ctrl": true, "shift": true},
		"fullscreen": {"key": 122},
		"zoom_in": null,
		"zoom_out": null,
		"zoom_reset": null,
		"toggle_sidebars": {"key": 66, "ctrl": true},
		"action_control": {"key": 114},
		"theme_window": null,
		"import_theme": null,
		"export_theme": null,
		"reset_layout": null,
		"about_window": null,
		"edit": {"key": 49},
		"paint": {"key": 50},
		"display": {"key": 51},
		"animate": {"key": 52},
		"keybindings_window": null,
		"load_keymap": null,
		"import_keymap": null,
		"export_keymap": null,
		"settings_window": null,
		"import_settings": null,
		"export_settings": null,
		"copy": {"key": 67, "ctrl": true},
		"cut": {"key": 88, "ctrl": true},
		"paste": {"key": 86, "ctrl": true},
		"undo": {"key": 90, "ctrl": true},
		"redo": {"key": 90, "ctrl": true, "shift": true},
		"edit_history": null,
		"edit_session": null,
		"outliner_toggle": {"key": 115},
		"cube_counter": null,
		"sort_outliner": null,
		"unlock_everything": null,
		"element_colors": null,
		"select_window": {"key": 70, "ctrl": true},
		"invert_selection": {"key": 73, "ctrl": true},
		"select_all": {"key": 65},
		"hide_everything_except_selection": {"key": 72, "ctrl": true},
		"add_group": {"key": 71, "ctrl": true},
		"group_elements": {"key": 71, "ctrl": true, "shift": true},
		"collapse_groups": null,
		"unfold_groups": null,
		"edit_bedrock_binding": null,
		"add_mesh": {"key": 65, "shift": true},
		"selection_mode": null,
		"create_face": {"key": 70},
		"convert_to_mesh": null,
		"invert_face": null,
		"extrude_mesh_selection": {"key": 69},
		"extrude_spline_selection": {"key": 69},
		"inset_mesh_selection": {"key": 73},
		"loop_cut": {"key": 82, "ctrl": true},
		"dissolve_edges": {"key": 88, "shift": true},
		"merge_vertices": {"key": 77, "shift": true},
		"merge_meshes": {"key": 77},
		"split_mesh": null,
		"import_obj": null,
		"add_cube": {"key": 78, "ctrl": true},
		"edit_material_instances": null,
		"add_texture_mesh": null,
		"add_locator": null,
		"add_null_object": null,
		"view_mode": {"key": 90, "shift": true},
		"preview_checkerboard": null,
		"uv_checkerboard": null,
		"toggle_shading": {"key": 90},
		"toggle_motion_trails": null,
		"screenshot_model": {"key": 80, "ctrl": true},
		"record_model_gif": null,
		"timelapse": null,
		"screenshot_app": null,
		"toggle_quad_view": {"key": 81, "ctrl": true, "alt": true},
		"focus_on_selection": {"key": 110},
		"toggle_camera_projection": {"key": 101},
		"camera_initial": {"key": 97},
		"camera_top": {"key": 104},
		"camera_bottom": {"key": 98},
		"camera_south": {"key": 100},
		"camera_north": {"key": 102},
		"camera_east": {"key": 103},
		"camera_west": {"key": 105},
		"transform_space": null,
		"rotation_space": null,
		"slider_pos_x": null,
		"slider_pos_y": null,
		"slider_pos_z": null,
		"slider_size_x": null,
		"slider_size_y": null,
		"slider_size_z": null,
		"slider_inflate": null,
		"slider_stretch_x": null,
		"slider_stretch_y": null,
		"slider_stretch_z": null,
		"slider_rotation_x": null,
		"slider_rotation_y": null,
		"slider_rotation_z": null,
		"slider_origin_x": null,
		"slider_origin_y": null,
		"slider_origin_z": null,
		"scale": null,
		"rotate_x_cw": null,
		"rotate_x_ccw": null,
		"rotate_y_cw": null,
		"rotate_y_ccw": null,
		"rotate_z_cw": null,
		"rotate_z_ccw": null,
		"flip_x": null,
		"flip_y": null,
		"flip_z": null,
		"center_x": null,
		"center_y": null,
		"center_z": null,
		"center_all": null,
		"move_up": {"key": 38},
		"move_down": {"key": 40},
		"move_left": {"key": 37},
		"move_right": {"key": 39},
		"move_forth": {"key": 33},
		"move_back": {"key": 34},
		"toggle_visibility": {"key": 72},
		"toggle_locked": null,
		"toggle_export": null,
		"toggle_autouv": null,
		"toggle_shade": null,
		"toggle_mirror_uv": null,
		"update_autouv": null,
		"origin_to_geometry": null,
		"rescale_toggle": null,
		"bone_reset_toggle": null,
		"remove_blank_faces": null,
		"import_texture": {"key": 84, "ctrl": true},
		"create_texture": {"key": 84, "ctrl": true, "shift": true},
		"save_textures": {"key": 83, "alt": true},
		"change_textures_folder": null,
		"animated_textures": null,
		"animated_texture_frame": null,
		"uv_rotation": null,
		"uv_grid": null,
		"uv_maximize": null,
		"uv_turn_mapping": null,
		"uv_auto": null,
		"uv_rel_auto": null,
		"uv_mirror_x": null,
		"uv_mirror_y": null,
		"uv_transparent": {"key": 88, "alt": true},
		"uv_reset": null,
		"uv_apply_all": null,
		"cullface": null,
		"auto_cullface": null,
		"face_tint": null,
		"slider_face_tint": null,
		"snap_uv_to_pixels": null,
		"toggle_uv_overlay": null,
		"brush_tool": {"key": 66},
		"fill_tool": null,
		"eraser": {"key": 69, "ctrl": true},
		"color_picker": null,
		"draw_shape_tool": {"key": 85},
		"gradient_tool": null,
		"copy_paste_tool": {"key": 77},
		"draw_shape_type": null,
		"fill_mode": null,
		"mirror_painting": null,
		"color_erase_mode": null,
		"lock_alpha": null,
		"painting_grid": {"key": 71, "shift": true},
		"pixel_grid": {"key": 71, "shift": true},
		"slider_brush_size": null,
		"slider_brush_softness": null,
		"slider_brush_opacity": null,
		"add_to_palette": null,
		"import_palette": null,
		"export_palette": null,
		"generate_palette": null,
		"sort_palette": null,
		"load_palette": null,
		"slider_color_h": null,
		"slider_color_s": null,
		"slider_color_v": null,
		"pick_screen_color": null,
		"add_display_preset": null,
		"apply_display_preset": null,
		"gui_light": null,
		"slider_animation_length": null,
		"set_animation_end": {"key": 35, "ctrl": true},
		"add_animation": null,
		"load_animation_file": null,
		"export_animation_file": null,
		"save_all_animations": null,
		"ik_enabled": null,
		"slider_ik_chain_length": null,
		"lock_motion_trail": null,
		"add_keyframe": {"key": 73},
		"move_keyframe_back": {"key": 37},
		"move_keyframe_forth": {"key": 39},
		"previous_keyframe": null,
		"next_keyframe": null,
		"slider_keyframe_time": null,
		"keyframe_uniform": null,
		"keyframe_interpolation": {"key": 84},
		"reset_keyframe": null,
		"resolve_keyframe_expressions": null,
		"change_keyframe_file": null,
		"reverse_keyframes": null,
		"flip_animation": null,
		"timeline_graph_editor": {"key": 114, "ctrl": true},
		"graph_editor_zero_line": null,
		"play_animation": {"key": 32},
		"slider_animation_speed": null,
		"jump_to_timeline_start": {"key": 36},
		"jump_to_timeline_end": {"key": 35},
		"timeline_frame_back": {"key": 188},
		"timeline_frame_forth": {"key": 190},
		"bring_up_all_animations": null,
		"fold_all_animations": null,
		"clear_timeline": null,
		"select_effect_animator": null,
		"timeline_focus": null,
		"add_marker": {"key": 77},
		"plugins_window": null,
		"reload_plugins": null,
		"load_plugin": null,
		"load_plugin_from_url": null,
		"add_plugin": null,
		"remove_plugin": null,
		"project_window": null,
		"close_project": null,
		"convert_project": null,
		"open_model": {"key": 79, "ctrl": true},
		"open_from_link": null,
		"extrude_texture": null,
		"export_over": {"key": 83, "ctrl": true},
		"upload_sketchfab": null,
		"share_model": null,
		"save_project": {"key": 83, "ctrl": true, "alt": true},
		"save_project_as": {"key": 83, "ctrl": true, "shift": true, "alt": true},
		"import_project": null,
		"export_blockmodel": null,
		"import_java_block_model": null,
		"export_bedrock": null,
		"export_entity": null,
		"export_obj": null,
		"export_gltf": null,
		"export_class_entity": null,
		"export_optifine_full": null,
		"export_optifine_part": null,
		"import_optifine_part": null,
		"toggle_skin_layer": null,
		"export_minecraft_skin": null,
		"explode_skin_model": null
	}
}